import React from "react";

import { MAP_ENTITY_TYPES } from "@app/util/map/consts";

import DefaultKeysItem from "./DefaultKeysItem";

interface Props {}

const DefaultKeys: React.FC<Props> = () => {
  return (
    <>
      {MAP_ENTITY_TYPES.map((entityType) => (
        <DefaultKeysItem entityType={entityType} key={entityType} />
      ))}
    </>
  );
};

export default DefaultKeys;
